<template>
    <div>
        <div class="block sm:flex sm:flex-wrap sm:justify-between">
            <div class="w-full md:w-5/12 mb-2 flex">
                <div class="w-40 flex-shrink-0">
                    {{ $t('order.number') }}
                </div>
                <div>{{ order.saleOrdNum }}</div>
            </div>

            <div class="w-full md:w-5/12 mb-2 flex">
                <div class="w-40 flex-shrink-0">{{ $t('order.date') }}</div>
                <div>
                    {{ order.saleOrdCreDate | formatDate('fullDateTime') }}
                </div>
            </div>

            <div class="w-full md:w-5/12 mb-2 flex">
                <div class="w-40 flex-shrink-0">
                    {{ $t('account.delivery.site') }}
                </div>
                <div>
                    <div>{{ cmpySiteName }}</div>
                    <div v-if="showCmpySiteAddr" class="mt-2">
                        {{ cmpySiteAddr }}
                    </div>
                </div>
            </div>
            <div class="w-full md:w-5/12 mb-2 flex">
                <div class="w-40 flex-shrink-0">
                    {{ $t('order.status') }}
                </div>
                <div class="flex flex-col">
                    <div>{{ $t('order.status.' + order.saleOrdStsCode) }}</div>
                    <buttonRefreshPayment v-if="false" :order="order" />
                </div>
            </div>
            <div class="w-full md:w-5/12 mb-2 flex">
                <div class="w-40 flex-shrink-0">
                    {{ $t('order.payment.method') }}
                </div>
                <div
                    v-if="order.saleOrdStsCode === 'C' && order.pymtTotAmt <= 0"
                >
                    {{ '/' }}
                </div>
                <div v-else>
                    {{
                        order.pymtSrvcPrvdId && order.pymtMthdId
                            ? $t(
                                  'order.payment.method.history.' +
                                      order.pymtSrvcPrvdId +
                                      '.' +
                                      order.pymtMthdId
                              )
                            : $t('order.payment.notSelect')
                    }}
                </div>
            </div>
            <div
                class="w-full md:w-5/12 mb-2 flex"
                v-if="order.saleOrdStsCode === 'C'"
            >
                <div class="w-40 flex-shrink-0">
                    {{ $t('order.dlvr.status') }}
                </div>
                <div class="flex flex-col">
                    <div>
                        {{
                            $t(
                                'order.dlvr.status.' + dlvrStsCode(order),
                                dlvrDate(order)
                            )
                        }}
                    </div>
                    <buttonRefreshPayment v-if="false" :order="order" />
                </div>
            </div>
        </div>
        <!-- 2021-10-25 update: replace by delivery status -->
        <div class="mb-2 flex" v-if="order.schdDlvrDate && false">
            <div class="w-40 flex-shrink-0">
                {{ $t('order.delivery.date') }}
            </div>
            <div>
                {{ order.schdDlvrDate | formatDate('fulldate') }}
            </div>
        </div>
        <div class="mb-2 flex">
            <div class="w-40 flex-shrink-0">
                <msgSlot
                    msgKey="order.credit.point.earn"
                    class="flex items-center"
                >
                    <template #slot0>
                        <div class="icon text-primary ml-1">
                            <tryhalaCoinSvg />
                        </div>
                    </template>
                </msgSlot>
            </div>
            <div>{{ order.rcvCrdtPntQty || '/' }}</div>
        </div>
        <productTable
            class="mt-8"
            :list="salesOrderProductList"
            :dsctAmt="order.dsctTotAmt"
            :readonly="true"
            :showCrdtPntEarnAmt="false"
            headerBg="bg-transparent"
            headerBorder="border-b border-gray-100 border-dotted"
            rowBorder="border-b border-gray-100 border-dotted"
        >
            <template #leftInfo class="flex flex-col">
                <div v-if="order.cpn" class="flex flex-wrap">
                    <div class="text-lg w-40">
                        {{ $t('cart.use.coupon') + ':' }}
                    </div>
                    <div class="text-lg px-4">
                        {{
                            '$' +
                                order.cpn.cpnDsctAmt +
                                '-' +
                                $t(order.cpn.cpnTypeDesp)
                        }}
                    </div>
                </div>
                <div v-if="order.spendCrdtPntQty" class="flex flex-wrap">
                    <div class="text-lg w-40">
                        <msgSlot
                            :msgKey="$t('cart.use.msg.slot') + ':'"
                            class="flex items-center"
                        >
                            <template #slot0>
                                <div class="icon text-primary">
                                    <tryhalaCoinSvg />
                                </div>
                            </template>
                        </msgSlot>
                    </div>
                    <div class="text-lg px-4">
                        {{ order.spendCrdtPntQty }}
                    </div>
                </div>
            </template>
        </productTable>
    </div>
</template>

<script>
import productTable from '@/components/productTable.vue';
import formatDate from '@/components/formatDateFilter';
import msgSlot from '@/components/msgSlot';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import buttonRefreshPayment from '@/components/buttonRefreshPayment.vue';

export default {
    components: { productTable, msgSlot, tryhalaCoinSvg, buttonRefreshPayment },
    filters: { formatDate },
    props: { order: { required: true } },
    computed: {
        cmpySite() {
            const site = this.$store.getters.getCmpySiteById(
                this.order.cmpySiteKey
            );
            return site;
        },
        cmpySiteName() {
            return this.cmpySite?.cmpySiteName || '/';
        },
        cmpySiteAddr() {
            return this.cmpySite?.cmpySiteAddr || '';
        },
        showCmpySiteAddr() {
            return this.$store.state.user?.custTypeCode === 'PUB';
        },
        salesOrderProductList() {
            // Do not show bundle product's component to customer
            return this.order.saleOrdProdList.filter(p => !p.bndlProdKey);
        },
        dlvrStsCode() {
            return saleOrd => {
                return saleOrd.pickOrdKey
                    ? !saleOrd.pickOrdActlDlvrDate
                        ? saleOrd.pickOrdSchdDlvrDate
                            ? 'scheduled'
                            : 'picking'
                        : 'success'
                    : 'pending';
            };
        },
        dlvrDate() {
            return saleOrd => {
                if (this.dlvrStsCode(saleOrd) === 'success')
                    return formatDate(saleOrd.pickOrdActlDlvrDate, 'fulldate');
                else if (this.dlvrStsCode(saleOrd) === 'scheduled')
                    return formatDate(saleOrd.pickOrdSchdDlvrDate, 'fulldate');
            };
        }
    }
};
</script>
